"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
var _TagCloseButton = require("../../components/TagCloseButton/TagCloseButton.styles");
var _marginMixin = require("../marginMixin");
var _typographyMixin = require("../typographyMixin");
var TagMixin = function TagMixin(props) {
  var appearance = props.appearance,
    size = props.size,
    textTransform = props.textTransform;
  return (0, _styledToken.default)({
    backgroundColor: "Tag.colors." + appearance + ".background",
    borderRadius: 'Tag.borderRadius',
    color: "Tag.colors." + appearance + ".fontColor",
    focusShadow: 'Tag.boxShadow.focus',
    fontType: "Tag.fontTypes." + size,
    horizontalPadding: "Tag.horizontalPadding." + size,
    targetPadding: 'Tag.targetPadding',
    verticalPadding: 'Tag.verticalPadding'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      borderRadius = _ref.borderRadius,
      color = _ref.color,
      focusShadow = _ref.focusShadow,
      fontType = _ref.fontType,
      horizontalPadding = _ref.horizontalPadding,
      targetPadding = _ref.targetPadding,
      verticalPadding = _ref.verticalPadding;
    return (0, _styledComponents.css)(["", " display:inline-flex;align-items:center;vertical-align:top;border-radius:", "px;padding:", "px ", "px;text-transform:", ";background-color:", ";&,", "{color:", ";}", "{margin-left:", "px;", "{box-shadow:none;}}&:focus-within{box-shadow:", ";}& > ", "{display:inline-block;margin-right:", "px;}", ""], (0, _typographyMixin.typographyMixin)(Object.assign({}, props, {
      fontType: fontType,
      fontTypeIconAlignment: false
    })), borderRadius, verticalPadding, horizontalPadding, textTransform, backgroundColor, _TagCloseButton.StyledTagCloseButton, color, _TagCloseButton.StyledTagCloseButton, horizontalPadding / 2 - targetPadding, _Icon.StyledIcon, focusShadow, _Icon.StyledIcon, horizontalPadding / 2, (0, _marginMixin.marginMixin)(Object.assign({}, props)));
  })(props);
};
exports.TagMixin = TagMixin;